import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { DialogService } from '@siemens/component-lib';
import { CreateWorkflowComponent } from '../create-workflow.component';
import { ConfirmationDialogData } from '../../../shared/interfaces/miscellaneous/ConfirmationDialogData';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { CreateWorkflowOperations } from '../create-workflow.operations';
import { filter, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-create-workflow-handler',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowDialogHandlerComponent {
    private dialog = inject(DialogService);
    private destroyRef = inject(DestroyRef);

    public openCreateWorkflowDialog(): void {
        this.dialog.open(CreateWorkflowComponent, {
            width: '1000px',
            overlayClickHandler: this.onDialogClose.bind(this)
        });
        // TODO: process the dialog result
    }

    protected onDialogClose(): void {
        this.dialog
            .open<boolean, ConfirmationDialogData>(
                ConfirmationDialogComponent,
                CreateWorkflowOperations.getConfirmationDialogData()
            )
            .afterClosed.pipe(
                filter((result: boolean) => !!result),
                tap(() => this.dialog.getCurrentDialogRef().close()),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
    }
}
